import { render } from "./CallHelpTel.vue?vue&type=template&id=c5f83660&scoped=true"
import script from "./CallHelpTel.vue?vue&type=script&lang=js"
export * from "./CallHelpTel.vue?vue&type=script&lang=js"

import "./CallHelpTel.vue?vue&type=style&index=0&id=c5f83660&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\kevin.chang\\Documents\\hzn\\oversea-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f83660"]])

export default __exports__